import React from 'react'
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap'

const ZoomIcon = ({
    item,
    currentId,
    handleClick,
}) => {
    if (!item) return null

    const itemId = item?._id || item?.picture?._id || item?.picture?.img || item?.img
    const visible = itemId === currentId

    const handleZoomClick = (event) => {
        event.stopPropagation()
        handleClick(item)
    }

    return (
        <button
            type="button"
            className={`zoomIcon ${visible ? 'visible' : ''}`}
            onClick={handleZoomClick}
            aria-label="Открыть изображение"
        >
            <ZoomOutMapIcon />
            <span>Открыть</span>
        </button>
    )
}

export default ZoomIcon